import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react-atlantic/react-atlantic/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import { RadioButtons, RadioCircular } from './views';
import { WrapperVertical } from '../../gatsby-theme-docz/components/Wrapper';
export const values = [{
  value: 'UK',
  label: 'Anglie 🇬🇧'
}, {
  value: 'CZ',
  label: 'Česko 🇨🇿'
}];
export const _frontmatter = {};
const layoutProps = {
  values,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1 {...{
      "id": "radio"
    }}>{`Radio`}</h1>
    <p>{`Component to display switch between defined options`}</p>
    <h2 {...{
      "id": "common-usage"
    }}>{`Common usage`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`import React, { useState } from 'react';
import { RadioButtons, RadioButtonProps } from '@atlasgroup/react-atlantic';

const Component = () => {
    const values = [
        { value: 'UK', label: 'England 🇬🇧' },
        { value: 'CZ', label: 'Czech Republic 🇨🇿' },
    ];
    const [value, setValue] = useState<string>(values[0].value);

    const onChange: RadioButtonProps['onChange'] = (e) => setValue(e.currentTarget.value);

    return <RadioButtons values={values} value={value} onChange={onChange} groupName="groupToFocusBy" />;
};
`}</code></pre>
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h2>
    <h3 {...{
      "id": "buttons"
    }}>{`Buttons`}</h3>
    <Playground __position={0} __code={'<WrapperVertical>\n  <RadioButtons values={values} value=\"UK\" />\n  <RadioCircular values={values} value=\"CZ\" />\n</WrapperVertical>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      RadioButtons,
      RadioCircular,
      WrapperVertical,
      DefaultLayout,
      values,
      _frontmatter
    }} mdxType="Playground">
    <WrapperVertical mdxType="WrapperVertical">
        <RadioButtons values={values} value="UK" mdxType="RadioButtons" />
        <RadioCircular values={values} value="CZ" mdxType="RadioCircular" />
    </WrapperVertical>
    </Playground>
    <h2 {...{
      "id": "disabled-values"
    }}>{`Disabled values`}</h2>
    <blockquote>
      <p parentName="blockquote">{`Values can be disabled by providing them isDisabled value in values definition → defaults to false`}</p>
    </blockquote>
    <Playground __position={1} __code={'<RadioButtons\n  values={[\n    { value: \'UK\', label: \'Anglie 🇬🇧\', isDisabled: true },\n    { value: \'CZ\', label: \'Česko 🇨🇿\' },\n  ]}\n  value=\"UK\"\n/>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      RadioButtons,
      RadioCircular,
      WrapperVertical,
      DefaultLayout,
      values,
      _frontmatter
    }} mdxType="Playground">
    <RadioButtons values={[{
        value: 'UK',
        label: 'Anglie 🇬🇧',
        isDisabled: true
      }, {
        value: 'CZ',
        label: 'Česko 🇨🇿'
      }]} value="UK" mdxType="RadioButtons" />
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      